module.exports = __webpack_public_path__ + "static/media/EECS_598_Final_Project.e892b498.pdf";